var _path, _mask, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNonprofit = function SvgNonprofit(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M59.995 119.989c33.134 0 59.994-26.86 59.994-59.995C119.989 26.861 93.129 0 59.994 0 26.861 0 0 26.86 0 59.995c0 33.134 26.86 59.994 59.995 59.994z",
    fill: "#D7DBDB"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "a",
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 120,
    height: 120
  }, /*#__PURE__*/React.createElement("path", {
    d: "M59.995 119.989c33.134 0 59.994-26.86 59.994-59.995C119.989 26.861 93.129 0 59.994 0 26.861 0 0 26.86 0 59.995c0 33.134 26.86 59.994 59.995 59.994z",
    fill: "#D7DBDB"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.011 89a17.713 17.713 0 011.112-6.838 17.425 17.425 0 013.64-5.85 16.995 16.995 0 015.59-3.929A16.687 16.687 0 0139 71c2.284 0 4.545.47 6.647 1.383a16.995 16.995 0 015.59 3.93 17.425 17.425 0 013.64 5.849A17.713 17.713 0 0155.989 89H22.01zM72.008 89a11.22 11.22 0 01.785-4.559 11.537 11.537 0 012.57-3.9 12.022 12.022 0 013.945-2.619A12.374 12.374 0 0184 77c1.612 0 3.208.314 4.692.922 1.484.609 2.826 1.5 3.945 2.62a11.537 11.537 0 012.57 3.9A11.22 11.22 0 0195.992 89H72.008z",
    fill: "#BFC8C8"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#868A8A",
    d: "M32 49h56v32H32z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 44,
    y: 21,
    width: 32,
    height: 16,
    rx: 2,
    fill: "#868A8A"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M48 25h24v8H48z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#868A8A",
    d: "M46 37h4v2h-4zM70 37h4v2h-4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#727676",
    d: "M30 49h60v-4H30z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#868A8A",
    d: "M28 45h64v-6H28zM30 89h60v-8H30zM-3 89h126v31H-3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D4DADA",
    d: "M36 54h29v23H36z"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M61 54h2l-8 23h-2l8-23zM59 54h1l-8 23h-1l8-23z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D4DADA",
    d: "M69 54h15v27H69z"
  }))));
};
export { SvgNonprofit as ReactComponent };
export default "data:image/svg+xml;base64,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";